import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, ArrowRight, CheckCircle2 } from "lucide-react";

export default function Hero() {
  const navigate = useNavigate();
  return (
    <section id="accueil" className="relative pt-32 pb-20 overflow-hidden bg-brand-ivoire">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div className="animate-fade-up">
          <button onClick={() => document.getElementById("referent-pitch")?.scrollIntoView({ behavior: "smooth" })} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-soft text-brand-green text-sm font-medium mb-6 hover:bg-brand-lime/40 transition-colors" data-testid="hero-referent-banner">
            Nouveau : déléguez vos états des lieux à un référent local
            <ArrowRight className="w-4 h-4" />
          </button>
          <h1 className="font-display text-5xl lg:text-6xl font-semibold leading-[1.05] text-brand-greenDeep">
            Votre gestion locative,{" "}
            <span className="relative inline-block">
              sans la paperasse.
              <span className="absolute left-0 -bottom-1 w-full h-3 bg-brand-lime/60 -z-10 rounded" />
            </span>
          </h1>
          <p className="mt-6 text-lg text-brand-green/70 leading-relaxed max-w-xl">
            Suivez vos loyers, générez vos quittances et préparez votre déclaration de revenus fonciers au même endroit. L'IA s'occupe du reste.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <button
              onClick={() => navigate("/connexion")}
              className="group inline-flex items-center gap-2 px-7 py-4 rounded-full bg-brand-lime hover:bg-brand-limeDark text-brand-greenDeep font-semibold text-lg transition-all shadow-md hover:shadow-lg"
              data-testid="hero-cta"
            >
              Créer mon compte gratuit
              <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </button>
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-brand-green/60 text-sm font-medium">
            <span className="inline-flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4 text-brand-limeDark" /> Gratuit pour 1 bien</span>
            <span className="inline-flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4 text-brand-limeDark" /> Sans carte bancaire</span>
            <span className="inline-flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4 text-brand-limeDark" /> Sans engagement</span>
          </div>
        </div>

        <div className="relative animate-fade-up" style={{ animationDelay: "0.15s" }}>
          <div className="relative rounded-3xl overflow-hidden shadow-2xl border border-brand-soft bg-white">
            <img
              src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80"
              alt="Gestion locative"
              className="w-full h-[300px] object-cover"
            />
            <div className="p-5">
              <div className="flex items-center justify-between mb-4">
                <p className="font-semibold text-brand-greenDeep">Portefeuille immobilier</p>
                <span className="text-xs px-2.5 py-1 rounded-full bg-brand-soft text-brand-green font-medium">5 biens</span>
              </div>
              {[["12 Rue de Rivoli", "Occupé", true], ["3 Rue de la Paix", "Occupé", true], ["45 Bd Saint-Germain", "Vacant", false]].map(([addr, st, ok], i) => (
                <div key={i} className="flex items-center justify-between py-3 border-b border-brand-soft last:border-0">
                  <div className="flex items-center gap-3">
                    <span className="w-8 h-8 rounded-lg bg-brand-soft" />
                    <span className="text-sm font-medium text-brand-green">{addr}</span>
                  </div>
                  <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${ok ? "bg-brand-lime/30 text-brand-greenDeep" : "bg-orange-100 text-orange-700"}`}>{st}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="absolute -bottom-5 -left-5 bg-white rounded-2xl shadow-xl p-4 border border-brand-soft animate-floaty">
            <p className="text-xs text-brand-green/60">Revenus du mois</p>
            <p className="text-2xl font-bold text-brand-greenDeep">5 340 €</p>
          </div>
        </div>
      </div>
    </section>
  );
}
